import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import styled from '@emotion/styled'
import {
  selectBrand,
  selectGroupOrder,
  useAppSelector,
} from '@open-tender/cloud'
import { Body, Box, Headline } from 'components'
import GroupOrderReviewGuest from './GroupOrderReviewGuest'
import GroupOrderReviewOwner from './GroupOrderReviewOwner'

export const GroupOrderCartView = styled(Box)`
  opacity: 0;
  animation: slide-up 0.25s ease-in-out 0.375s forwards;
  max-width: ${(props) => props.theme.layout.maxWidth};
  margin: ${(props) => props.theme.layout.padding} auto;
  padding: ${(props) => props.theme.layout.padding};
  @media (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    margin: ${(props) => props.theme.layout.paddingMobile} auto;
    padding: ${(props) => props.theme.layout.paddingMobile};
  }
`

export const GroupOrderCartSection = styled.div`
  margin: 0 0 3rem;
`

export const GroupOrderCartSectionHeader = styled.div`
  margin: 0 0 3rem;
`

export const GroupOrderCartTitle = styled(Headline)`
  margin: 0 0 0 -0.1rem;
  font-size: ${(props) => props.theme.fonts.sizes.xBig};
  @media (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    font-size: ${(props) => props.theme.fonts.sizes.big};
  }
`

export const GroupOrderCartSubtitle = styled(Body)`
  margin: 1rem 0 0;
  font-size: ${(props) => props.theme.fonts.sizes.small};
  @media (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    font-size: ${(props) => props.theme.fonts.sizes.xSmall};
  }
`

const GroupOrderReview = () => {
  const navigate = useNavigate()
  const { title: siteTitle } = useAppSelector(selectBrand) || {}
  const groupOrder = useAppSelector(selectGroupOrder)
  const { cartId, cartOwner, cartGuest } = groupOrder

  useEffect(() => {
    window.scrollTo(0, 0)
    if (!cartId) navigate(`/account`)
  }, [cartId, navigate])

  return (
    <>
      <Helmet>
        <title>Review Group Order | {siteTitle}</title>
      </Helmet>
      {cartGuest ? (
        <GroupOrderReviewGuest />
      ) : cartOwner ? (
        <GroupOrderReviewOwner />
      ) : null}
    </>
  )
}

export default GroupOrderReview
